@if (CMSData) {
  <div class="col-md-12 underline margin-top   "
[ngClass]="{'selectTile' : userInputDetail['selected'],
'unselectedTile': !userInputDetail['selected'] && isProductSelected,
'Container-3-tile':noOfProduct==3,'Container-2-tile':noOfProduct==2,'Container-1-tile':noOfProduct==1}"  
    [ngStyle]="{'width':widthSize+'%'}" [formGroup]="parent">
    <div >
      <div class="ds-flex gutter "  >
        <div class="Rectangle"  >
        </div>
        <div class="Oval">
          <img [id]="'img-'+prodID" class="" alt="" src="./assets/images/{{userInputDetail['imageName']}}">
        </div>
        <!-- ./assets/images/{{userInputDetail['imageName']}} -->
        <div class="Rectangle"  >
          <!-- {{userInputDetail['imageName']}} -->
        </div>
      </div>
      <div class="margin-top-30 product-name" [id]="'pName-'+prodID" aria-level="2">
        {{product['productName']}}
      </div>
      <div class="flex-center "  >
        <div class="Rectangle-checkbox" >
          <input
            type="checkbox"
            [id]="userInputDetail.controlName"
            [name]="userInputDetail.controlName"
            [formControlName]="userInputDetail.controlName"
            class="form-control "
            aria-invalid="false"
            [(ngModel)]="userInputDetail['selected']"
            [value]="userInputDetail['selected']"
            (change)="onProductSelect(userInputDetail['selected'],userInputDetail['productName'],userInputDetail['productCode'])"
            />
            <label   [for]="userInputDetail.controlName" class="form-label wd-24" [attr.aria-label]="userInputDetail.controlName" [id]="'chkBox-'+prodID">
              <span class="visuallyhidden"> </span>
            </label>
          </div>
        </div>
        <div [id]="'pDesc-'+prodID" class="margin-top-30 tileBody" [ngClass]="{'tileBodyHeightforThreeProd':noOfProduct==3,'tileBodyHeightforTwoProd':noOfProduct ==2}">
          {{product['productDescription']}}
        </div>
        <div class="line-seperator margin-top-20"></div>
        <div class="more-detail" [ngClass]="{'tileBodyHeightforThreeProds':noOfProduct==3,'tileBodyHeightforTwoProds':noOfProduct ==2}">
          <span class="subtitle-features flex-first-a" [id]="'subTitle-'+prodID" aria-level="3">{{CMSData.string_MoreDetailsTitle}}</span>
          <!-- <ul class="list">
          <span class="icon icon-tick-circle reflect-modal-close" tabindex="0" aria-hidden="true"></span>
          <li value="oval-list" *ngFor="let detail of product['moreDetail'] " [id]="detail.url+'-'+prodID">
            <span class="oval-list"></span>
            {{ detail.text }}
          </li>
        </ul> -->
        <div class="dd-bullets">
          <div class="dd-bullets">
            <ul class="dd-bullets__list ">
              @for (detail of product['moreDetail']; track detail) {
                <li class="dd-bullets__item" alt="" [id]="detail.url+'-'+prodID" [ngClass]="(detail.url === 'url1' || detail.url === 'url2') ? 'dd-bullets__item--tick-filled-circle':'dd-bullets__item--cross-filled-circle'">
                {{ detail.text }}</li>
              }
            </ul>
          </div>
        </div>
      </div>
      <div class="line-seperator"></div>
      <div class=" document-section">
        <div class="subtitle-features-doc flex-first-a" [id]="'flex'+'-'+prodID">{{product['docDescription']}}</div>
        @for (doc of updatedProduct['documentLink']; track doc; let i = $index; let isFirst = $first) {
          <div  >
            <div class="flex-document" >
              <div class="flex-first" >
                <span [id]="getID(doc.name)+'-'+prodID" class="subtitle-features flex-first-a">{{doc.name}}</span>
                <span [id]="getID(doc.name)+'-size'+'-'+prodID" class="subtitle-list-features flex-first-b">
                {{doc.size}}</span>
              </div>
              <!-- <a [href]="doc['url']" target="_blank">
              <label (click)=test(doc.name) class="subtitle-list-features flex-second">{{doc.image}}</label>
            </a> -->
            @if (doc['size']!=='') {
              <div >
                <a tabindex="-1" [id]="updatedProduct['productCode'] + i +'-Document'" [href]="doc['url']" target="_blank" class="outline">
                  <img  tabindex="0" [id]="'pdf-'+prodID+i"  class="image-pdf reflect" [attr.alt]="'download-'+prodID+i+product['productName']+doc.name" src="./assets/images/pdfLink.png">
                </a>
              </div>
            }
            @if (isFirst) {
              <div class="line-seperator"></div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
}